import ScenarioInput from './ScenarioInput'
import React from 'react'
import upGreen from '../../assets/images/up-green.svg'
import downRed from '../../assets/images/down-red.svg'

const checkDataInput = val => {
  if (val === null || val === undefined || val === '') {
    return false
  } else {
    return true
  }
}
export const InputTypeRealEstate = ({
  data,
  setParamCalculate,
  isResetData,
  setIsResetData,
  flagChangeScenario2 = false,
  setDataValueChange1 = () => {},
}) => {
  const setDataByCode = (attribute, valSlider, newValue) => {
    setIsResetData(false)
    setParamCalculate(prev => {
      if (attribute === 'close' || attribute === 'vol_forecast_annualised') {
        prev[attribute] = valSlider
      } else {
        if (prev?.default_point) {
          prev.default_point[attribute] = !!valSlider ? valSlider : 0
        }
      }
      return { ...prev }
    })
    setDataValueChange1(prev => {
      let newPrev = prev.filter(it => it?.attribute !== attribute)
      newPrev.push({
        attribute: attribute,
        valSlider: valSlider,
        newValue: newValue,
      })
      return newPrev
    })
  }

  return (
    <>
      {checkDataInput(data?.total_real_estate_assets) && (
        <ScenarioInput
          title={'Total Real Estate Assets'}
          valueScenario={data?.total_real_estate_assets}
          attribute={'total_real_estate_assets'}
          setDataByCode={setDataByCode}
          isResetData={isResetData}
          isDisabledAction={flagChangeScenario2}
        />
      )}
      {checkDataInput(data?.cash_and_equivalents) && (
        <ScenarioInput
          title={'Cash & Equivalents'}
          valueScenario={data?.cash_and_equivalents}
          attribute={'cash_and_equivalents'}
          setDataByCode={setDataByCode}
          isResetData={isResetData}
          isDisabledAction={flagChangeScenario2}
        />
      )}
      {checkDataInput(data?.accounts_receivables) && (
        <ScenarioInput
          title={'Accounts Receivables'}
          valueScenario={data?.accounts_receivables}
          attribute={'accounts_receivables'}
          setDataByCode={setDataByCode}
          isResetData={isResetData}
          isDisabledAction={flagChangeScenario2}
        />
      )}
      {checkDataInput(data?.investment_in_debt_equity_securities) && (
        <ScenarioInput
          title={'Investment in Debt and Equity'}
          valueScenario={data?.investment_in_debt_equity_securities}
          attribute={'investment_in_debt_equity_securities'}
          setDataByCode={setDataByCode}
          isResetData={isResetData}
          isDisabledAction={flagChangeScenario2}
        />
      )}
      {checkDataInput(data?.goodwill) && (
        <ScenarioInput
          title={'Goodwill'}
          valueScenario={data?.goodwill}
          attribute={'goodwill'}
          setDataByCode={setDataByCode}
          isResetData={isResetData}
          isDisabledAction={flagChangeScenario2}
        />
      )}
      {checkDataInput(data?.other_intangibles) && (
        <ScenarioInput
          title={'Other Intangibles Total'}
          valueScenario={data?.other_intangibles}
          attribute={'other_intangibles'}
          setDataByCode={setDataByCode}
          isResetData={isResetData}
          isDisabledAction={flagChangeScenario2}
        />
      )}
      {checkDataInput(data?.other_assets_total) && (
        <ScenarioInput
          title={'Other Assets'}
          valueScenario={data?.other_assets_total}
          attribute={'other_assets_total'}
          setDataByCode={setDataByCode}
          isResetData={isResetData}
          isDisabledAction={flagChangeScenario2}
        />
      )}
      {checkDataInput(data?.close) && (
        <ScenarioInput
          title={'Share Price'}
          valueScenario={data?.close}
          attribute={'close'}
          setDataByCode={setDataByCode}
          isResetData={isResetData}
          isDisabledAction={flagChangeScenario2}
        />
      )}
      {checkDataInput(data?.vol_forecast_annualised) && (
        <ScenarioInput
          title={'Equity Volatility'}
          valueScenario={data?.vol_forecast_annualised}
          attribute={'vol_forecast_annualised'}
          setDataByCode={setDataByCode}
          isResetData={isResetData}
          isDisabledAction={flagChangeScenario2}
        />
      )}
    </>
  )
}

export const InputTypeInsurance = ({
  data,
  setParamCalculate,
  isResetData,
  setIsResetData,
  flagChangeScenario2 = false,
  setDataValueChange1 = () => {},
}) => {
  const setDataByCode = (attribute, valSlider, newValue) => {
    setIsResetData(false)
    setParamCalculate(prev => {
      if (attribute === 'close' || attribute === 'vol_forecast_annualised') {
        prev[attribute] = valSlider
      } else {
        if (prev?.default_point) {
          prev.default_point[attribute] = !!valSlider ? valSlider : 0
        }
      }
      return { ...prev }
    })
    setDataValueChange1(prev => {
      let newPrev = prev.filter(it => it?.attribute !== attribute)
      newPrev.push({
        attribute: attribute,
        valSlider: valSlider,
        newValue: newValue,
      })
      return newPrev
    })
  }

  return (
    <>
      {checkDataInput(data?.insurance_risk) && (
        <ScenarioInput
          title={'Insurance Risk'}
          valueScenario={data?.insurance_risk}
          attribute={'insurance_risk'}
          setDataByCode={setDataByCode}
          isResetData={isResetData}
          isDisabledAction={flagChangeScenario2}
        />
      )}
      {checkDataInput(data?.market_and_credit_risk) && (
        <ScenarioInput
          title={'Credit & Market Risk'}
          valueScenario={data?.market_and_credit_risk}
          attribute={'market_and_credit_risk'}
          setDataByCode={setDataByCode}
          isResetData={isResetData}
          isDisabledAction={flagChangeScenario2}
        />
      )}
      {checkDataInput(data?.close) && (
        <ScenarioInput
          title={'Equity Price'}
          valueScenario={data?.close}
          attribute={'close'}
          setDataByCode={setDataByCode}
          isResetData={isResetData}
          isDisabledAction={flagChangeScenario2}
        />
      )}
      {checkDataInput(data?.vol_forecast_annualised) && (
        <ScenarioInput
          title={'Equity Volatility'}
          valueScenario={data?.vol_forecast_annualised}
          attribute={'vol_forecast_annualised'}
          setDataByCode={setDataByCode}
          isResetData={isResetData}
          isDisabledAction={flagChangeScenario2}
        />
      )}
    </>
  )
}

export const InputTypeBanks = ({
  data,
  setParamCalculate,
  isResetData,
  setIsResetData,
  flagChangeScenario2,
  setDataValueChange1 = () => {},
}) => {
  const setDataByCode = (attribute, valSlider, newValue) => {
    setIsResetData(false)
    setParamCalculate(prev => {
      if (attribute === 'close' || attribute === 'vol_forecast_annualised') {
        prev[attribute] = valSlider
      } else {
        if (prev?.default_point) {
          prev.default_point[attribute] = !!valSlider ? valSlider : 0
        }
      }
      return { ...prev }
    })
    setDataValueChange1(prev => {
      let newPrev = prev.filter(it => it?.attribute !== attribute)
      newPrev.push({
        attribute: attribute,
        valSlider: valSlider,
        newValue: newValue,
      })
      return newPrev
    })
  }
  return (
    <>
      {checkDataInput(data?.risk_weighted_assets) && (
        <ScenarioInput
          title={'Risk Weighted Assets'}
          valueScenario={data?.risk_weighted_assets}
          attribute={'risk_weighted_assets'}
          setDataByCode={setDataByCode}
          isResetData={isResetData}
          isDisabledAction={flagChangeScenario2}
        />
      )}
      {checkDataInput(data?.close) && (
        <ScenarioInput
          title={'Equity Price'}
          valueScenario={data?.close}
          attribute={'close'}
          setDataByCode={setDataByCode}
          isResetData={isResetData}
          isDisabledAction={flagChangeScenario2}
        />
      )}
      {checkDataInput(data?.vol_forecast_annualised) && (
        <ScenarioInput
          title={'Equity Volatility'}
          valueScenario={data?.vol_forecast_annualised}
          attribute={'vol_forecast_annualised'}
          setDataByCode={setDataByCode}
          isResetData={isResetData}
          isDisabledAction={flagChangeScenario2}
        />
      )}
    </>
  )
}

export const InputTypeNonFinancials = ({
  data,
  setParamCalculate,
  isResetData,
  setIsResetData,
  flagChangeScenario2,
  setDataValueChange1 = () => {},
}) => {
  const setDataByCode = (attribute, valSlider, newValue) => {
    setIsResetData(false)
    setParamCalculate(prev => {
      if (attribute === 'close' || attribute === 'vol_forecast_annualised') {
        prev[attribute] = valSlider
      } else {
        if (prev?.default_point) {
          prev.default_point[attribute] = !!valSlider ? valSlider : 0
        }
      }
      return { ...prev }
    })
    setDataValueChange1(prev => {
      let newPrev = prev.filter(it => it?.attribute !== attribute)
      newPrev.push({
        attribute: attribute,
        valSlider: valSlider,
        newValue: newValue,
      })
      return newPrev
    })
  }
  return (
    <>
      {checkDataInput(data?.short_term_debt) && (
        <ScenarioInput
          title={'Short Term Debt'}
          valueScenario={data?.short_term_debt}
          attribute={'short_term_debt'}
          setDataByCode={setDataByCode}
          isResetData={isResetData}
          isDisabledAction={flagChangeScenario2}
        />
      )}
      {checkDataInput(data?.long_term_debt) && (
        <ScenarioInput
          title={'Long Term Debt'}
          valueScenario={data?.long_term_debt}
          attribute={'long_term_debt'}
          setDataByCode={setDataByCode}
          isResetData={isResetData}
          isDisabledAction={flagChangeScenario2}
        />
      )}
      {checkDataInput(data?.close) && (
        <ScenarioInput
          title={'Equity Price'}
          valueScenario={data?.close}
          attribute={'close'}
          setDataByCode={setDataByCode}
          isResetData={isResetData}
          isDisabledAction={flagChangeScenario2}
        />
      )}
      {checkDataInput(data?.vol_forecast_annualised) && (
        <ScenarioInput
          title={'Equity Volatility'}
          valueScenario={data?.vol_forecast_annualised}
          attribute={'vol_forecast_annualised'}
          setDataByCode={setDataByCode}
          isResetData={isResetData}
          isDisabledAction={flagChangeScenario2}
        />
      )}
    </>
  )
}

export const InputScenario2 = ({
  dataOld,
  dataNew,
  setParamCalculate,
  isResetData,
  setIsResetData,
  stage = 'stage1',
  flagChangeScenario1 = false,
}) => {
  const isDisabledAction = flagChangeScenario1 && stage === 'stage1'
  const setDataByCode = (attribute, val) => {
    setIsResetData(false)
    setParamCalculate(prev => {
      prev[attribute] = val
      return { ...prev }
    })
  }
  return (
    <>
      {checkDataInput(dataOld?.asset_value) && (
        <ScenarioInput
          title={'Market Value of Assets'}
          valueScenario={dataOld?.asset_value}
          valueScenarioNew={dataNew?.asset_value}
          attribute={'asset_value'}
          setDataByCode={setDataByCode}
          isResetData={isResetData}
          isDisabledAction={isDisabledAction}
        />
      )}
      {checkDataInput(dataOld?.asset_sigma) && (
        <ScenarioInput
          title={'Market Volatility of Assets'}
          valueScenario={dataOld?.asset_sigma}
          valueScenarioNew={dataNew?.asset_sigma}
          attribute={'asset_sigma'}
          setDataByCode={setDataByCode}
          isResetData={isResetData}
          isDisabledAction={isDisabledAction}
        />
      )}
    </>
  )
}

export const formatNumberInput = (num, attribute = null) => {
  if (attribute === 'vol_forecast_annualised' || attribute === 'asset_sigma') {
    return (num * 100).toFixed(1) + '%'
  } else {
    num = Math.round(num * 100) / 100
    return num.toString().replace(/^[+-]?\d+/, function (int) {
      return int.replace(/(\d)(?=(\d{3})+$)/g, '$1,')
    })
  }
}

export const formatNumberInputNotDecimal = (num, attribute = null) => {
  if (attribute === 'vol_forecast_annualised' || attribute === 'asset_sigma') {
    return (num * 100).toFixed(1) + '%'
  } else {
    if (attribute == "close") {
      num = (num * 100) / 100
      return (num).toFixed(2)
          .toString()
          .replace(/^[+-]?\d+/, function (int) {
            return int.replace(/(\d)(?=(\d{3})+$)/g, '$1,')
          })
    } else {
      num = Math.round(num * 100) / 100
      return parseInt(num)
          .toString()
          .replace(/^[+-]?\d+/, function (int) {
            return int.replace(/(\d)(?=(\d{3})+$)/g, '$1,')
          })
    }
  }
}

export const formatPersonInput = num => {
  if (num < 0) {
    return (
      <span className={'color-down-person'}>
        <img src={downRed} className="icon-up-down" />
        {Math.round(num * -1 * 100) + '%'}
      </span>
    )
  } else {
    return (
      <span className={'color-up-person'}>
        <img src={upGreen} className="icon-up-down" />
        {Math.round(num * 100) + '%'}
      </span>
    )
  }
}
